import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { CouchbaseTableDataset } from 'app/model/dataset/couchbase.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CouchbaseTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class CouchbaseTableDatasetAdapter extends TabularTypeDatasetAdapter<CouchbaseTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: CouchbaseTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(CouchbaseTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: CouchbaseTableDataset): Promise<CouchbaseTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, CouchbaseTableDataset.MODEL);
    }
}
